import fp from 'lodash/fp';
import { createSelector } from 'reselect';

export const getVisitConfigs = fp.get('visit.configs');

export const getAll = createSelector(getVisitConfigs, fp.get('all'));

export const getAllVisitConfigs = createSelector(getAll, fp.values);

export const getIsFetching = createSelector(
  getVisitConfigs,
  fp.get('fetching')
);

export const getIsFetched = createSelector(getVisitConfigs, fp.get('fetched'));

export const getFetchingError = createSelector(
  getVisitConfigs,
  fp.get('fetchingError')
);
